import { useMemo } from 'react';

import { bindActionCreators } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '@app/store/hooks';

import { addParkingCall, clearParkingCalls, removeParkingCall } from '../model/call-parking-slice';
import {
	addCall,
	clearCalls,
	patchCall,
	removeCall,
	setCallState,
	setCurrentCall,
	setScreenShare,
	updateMedia,
} from '../model/call-slice';
import {
	selectActiveCall,
	selectAllAcceptedCalls,
	selectAllCalls,
	selectCurrentCall,
	selectIncomingCalls,
	selectMissedCalls,
	selectParkingCall,
	selectPendingConferenceUsers,
	selectVisibleConferenceUsers,
} from '../model/selectors';

/**
 * Хук для работы со списком звонков и текущим активным звонком.
 */
export const useCallsList = () => {
	const dispatch = useAppDispatch();

	// селекторы
	const activeCall = useAppSelector(selectActiveCall);
	const currentCall = useAppSelector(selectCurrentCall);
	const activeConferenceUsers = useAppSelector(selectVisibleConferenceUsers);
	const pendingConferenceUsers = useAppSelector(selectPendingConferenceUsers);
	const missedCalls = useAppSelector(selectMissedCalls);
	const allCalls = useAppSelector(selectAllCalls);
	const allAcceptedCalls = useAppSelector(selectAllAcceptedCalls);
	const incomingCalls = useAppSelector(selectIncomingCalls);
	const parkingCalls = useAppSelector(selectParkingCall);

	// экшены-обёртки
	const actions = useMemo(
		() =>
			bindActionCreators(
				{
					addCall,
					patchCall,
					removeCall,
					clearCalls,
					clearParkingCalls,
					setCurrentCall,
					setCallState,
					updateMedia,
					setScreenShare,
					addParkingCall,
					removeParkingCall,
				},
				dispatch
			),
		[dispatch]
	);

	return {
		allCalls,
		missedCalls,
		activeCall,
		currentCall,
		activeConferenceUsers,
		pendingConferenceUsers,
		incomingCalls,
		parkingCalls,
		allAcceptedCalls,
		...actions,
	};
};
